import { AppStateErrorType } from '@tink/core/src/tinkLinkErrorCodes';
import { CommonError } from '../../../stores/app-state-errors';

export type ErrorWithType = CommonError & {
  errorType?: AppStateErrorType;
  credentialsId?: string;
};

export class ApplicationError extends Error {
  commonError: ErrorWithType;

  constructor(commonError: ErrorWithType) {
    super(commonError.errorReason);
    this.commonError = commonError;
  }
}
